import { GoogleAdsRequestTypeGq } from '../../../../../graphql/projects/models/GoogleAdsRequestTypeGq';

export const KeywordRequestTypes = [
  { type: GoogleAdsRequestTypeGq.RELATED, name: 'Related' },
  { type: GoogleAdsRequestTypeGq.URL, name: 'URL' },
  { type: GoogleAdsRequestTypeGq.CATEGORY, name: 'Category' },
  { type: GoogleAdsRequestTypeGq.EXACT, name: 'Exact' },
  { type: GoogleAdsRequestTypeGq.LONG_TAIL, name: 'Long tail' },
];
